import { lazy } from 'react';

// Main pages
export const Dashboard = lazy(() => import('../pages/Dashboard'));
export const Settings = lazy(() => import('../pages/Settings'));
export const AdminDashboard = lazy(() => import('../pages/admin/Dashboard'));

// Legal pages
export const TermsOfService = lazy(() => import('../pages/TermsOfService'));
export const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));

// Test pages
export const ImageGenerationTest = lazy(() => import('../components/ImageGenerationTest'));
export const TextOverlayTest = lazy(() => import('../components/TextOverlayTest').then(m => ({ default: m.TextOverlayTest })));
export const TestSpeechPage = lazy(() => import('../routes/test/speech'));
export const MusicTest = lazy(() => import('../components/test/MusicTest'));
export const VideoTest = lazy(() => import('../components/test/VideoTest'));
export const MinimaxiVideoTest = lazy(() => import('../components/test/MinimaxiVideoTest'));
export const PoemTest = lazy(() => import('../components/test/PoemTest'));
export const VideoOverlayTest = lazy(() => import('../components/test/VideoOverlayTest'));
export const StripeTest = lazy(() => import('../components/test/StripeTest'));
export const PaymentResult = lazy(() => import('../components/test/PaymentResult')); 